import { styled } from '@material-ui/core';
import { Flex } from "lqx-react";
import React from "react";

export const SwitchButton = ({ value, change }) => {
    const handleChange = (status) => () => change(status)

    const handleColor = (status) => status ? '#1d1e42' : '#3d77ba';
    return (
        <Flex row>
            <ButtonComponent bgProps={handleColor(!value)} onClick={handleChange(false)}>Single</ButtonComponent>
            <ButtonComponent bgProps={handleColor(value)} margin={'0 0 0 1px'} onClick={handleChange(true)}>Multiple</ButtonComponent>
        </Flex>
    )
}

interface IButtonComponent {
    bgProps: string,
    margin?: string
}

const ButtonComponent = styled(({ bgProps, ...rest }) => <button {...rest} />)({
    width: '94px',
    height: '26px',
    fontSize: '13px',
    fontFamily: 'Montserrat',
    fontWeight: 500,
    backgroundColor: (props: IButtonComponent) => props.bgProps,
    margin: (props: IButtonComponent) => props.margin,
    color: 'white',
    border: 'none'
});